import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useMediaQuery } from 'react-responsive';

import { bubEvents } from 'javascripts/shared/events/bub_events';

import styles from 'stylesheets/components/breadcrumbs.module';

const MAX_BREADCRUMB_LENGTH = 45;

export function Breadcrumbs(props) {
  const leftAlignScreenSize = useMediaQuery({ minWidth: 400 });

  function trackClicks(linkLabel) {
    bubEvents.track('Breadcrumbs', 'Clicked link', {
      label: 'Link label',
      value: linkLabel,
    });
  }

  function renderLink(level) {
    if (_.isEmpty(level.url)) {
      return (
        /* note that non-click behavior is also enforced via CSS */
        <a aria-label='Current' aria-current='page' href='#' onClick={(e) => e.preventDefault()} className={styles.breadcrumbLink}>
          {level.label}
        </a>
      );
    }
    return (
      <a
        className={styles.breadcrumbLink}
        href={level.url}
        onClick={() => trackClicks(level.label)}
      >
        {level.label}
      </a>
    );
  }

  function shouldRenderRightAligned() {
    if (leftAlignScreenSize) {
      return false;
    }
    const totalLength = _.reduce(
      props.levels,
      (count, level) => {
        return count + level.label.length;
      },
      0,
    );
    return totalLength >= MAX_BREADCRUMB_LENGTH;
  }

  function renderLevels() {
    return props.levels.map((level, index) => {
      return (
        <li className={styles.breadcrumb} key={`breadcrumb-${index}`}>
          {renderLink(level)}
        </li>
      );
    });
  }

  if (_.isEmpty(props.levels)) {
    return null;
  }

  return (
    <nav
      className={classNames(styles.breadcrumbs, { [styles.rightAlign]: shouldRenderRightAligned() })}
      aria-label='Breadcrumbs'
    >
      <ol className={styles.breadcrumbList}>{renderLevels()}</ol>
    </nav>
  );
}

Breadcrumbs.propTypes = {
  levels: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ),
};

Breadcrumbs.defaultProps = {
  levels: [],
};
